const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.artists.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindCompanyArtistsQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/companies/$id/artists')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    const {
      id: companyId
    } = params;
    queryClient.ensureQueryData(getFindCompanyArtistsQueryOptions(companyId));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});